var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-cropper-dailog dialog col-block"},[_c('cropper',{ref:"cropper",style:({
      'min-width': '160px',
      'min-height': '160px'
    }),attrs:{"stencil-component":"circle-stencil","src":_vm.param.url,"imageRestriction":'stencil',"default-size":_vm.defaultSize,"stencil-size":_vm.stencilSize,"stencil-props":{
      lines: {},
      handlers: {},
      movable: false,
      scalable: false,
      aspectRatio: 1
    },"canvas":{
      width: 320,
      height: 320
    }}}),_vm._v(" "),_c('div',{style:({ height: '20px' })}),_vm._v(" "),_c('div',{staticClass:"button-container row-block"},[_c('div',{style:({ flex: 1 })}),_vm._v(" "),_c('button',{staticClass:"main-button circle-button",on:{"click":function (e) { return _vm.sendResult(); }}},[_c('span',[_vm._v(_vm._s('Select'/* ___ */))])]),_vm._v(" "),_c('div',{style:({ flex: 1 })})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15289661","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/imageCropper.vue
// module id = null
// module chunks = 